import {
    avatar, image, status,
} from './styles/UserAvatarView'
import LetterAvatar from '../LetterAvatar'
import React from 'react'
import {UserAvatarViewProps} from './types'
import {isPropsObjectEqual} from 'utils/props'
import {styled} from 'stitches/config'
import {useTranslation} from 'react-i18next'


const StyledAvatar = styled('div', avatar)
const StyledImage = styled('img', image)
const StyledSvg = styled('div', {
    ...image,
    overflow: 'hidden',
})
const StyledStatus = styled('div', status)

const UserAvatarView = (props: UserAvatarViewProps): React.ReactElement => {
    const {
        name,
        size,
        src,
        iconOverride,
        isLetterAvatar,
        onImageError,
        imageState,
        connected,
        statusState,
        highlight,
        unread,
    } = props

    const {t} = useTranslation()

    const hasIconOverride = !!(iconOverride?.svg || iconOverride?.src)

    return (
        <StyledAvatar
            data-isletteravatar={isLetterAvatar ? !hasIconOverride : null}
            data-name='user-avatar'
            size={size}
        >
            {hasIconOverride ?
                <>
                    {iconOverride?.svg ?
                        <StyledSvg
                            dangerouslySetInnerHTML={{__html: iconOverride.svg}}
                            size={size}
                            state={imageState}
                            title={iconOverride.alt || name}
                        />
                        : null}
                    {iconOverride?.src ?
                        <StyledImage
                            onError={onImageError}
                            size={size}
                            src={iconOverride.src}
                            state={imageState}
                            title={iconOverride.alt || name}
                        />
                        : null}
                </>
                :
                <>
                    {!isLetterAvatar && !!src && (
                        <StyledImage
                            onError={onImageError}
                            size={size}
                            src={src}
                            state={imageState}
                            title={name}
                        />
                    )}
                    {!!isLetterAvatar && (
                        <LetterAvatar
                            highlight={highlight}
                            name={name}
                            size={size}
                            unread={unread}
                        />
                    )}
                </>}
            {!!connected && <StyledStatus aria-label={statusState === 'idle' ? 'Idle' : 'Active'} role={t('User status')} status={statusState} />}
        </StyledAvatar>
    )
}

UserAvatarView.defaultProps = {
    connected: false,
    highlight: false,
    iconOverride: undefined,
    imageState: undefined,
    name: undefined,
    size: undefined,
    src: undefined,
    statusState: undefined,
    unread: false,
}

export default React.memo(UserAvatarView, isPropsObjectEqual)
